<template>
    <div>
        <div class="col-md-4 pt-3 centre_sm_none show-con" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
            <div class="centre_content nano">
                <div class="nano-content content_list_nano">
                    <div class="home_move_banner d-block d-sm-none p-3">
                        <p>
                            <!--欢迎来到一带一路国家级信息服务平台<br>--> Welcome to the national Belt & Road-centered information service platform.
                        </p>
                    </div>
                    <!--<dl class="content_list mb-0" style="position: relative">
                        <dt class="list_title pl-3">
                            <i class="fa fa-home  mr-2"></i>
                            国别总览
                            <span class="myBtn" @click='goback()' v-if="!viewToggle">信息平台</span>
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="印度">印度</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="俄罗斯">俄罗斯</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="新加坡">新加坡</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="日本">日本</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="缅甸">缅甸</a>
                            </dd>
                            <dd class="p-2 mb-0 hot_back">
                                <a href="javascript:;" @click="columnClassify" value="泰国">泰国</a>

                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnClassify" value="马来西亚">马来西亚</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <router-link to="/countryreport/22/2018" class="nav-link text-primary">
                                    更多
                                </router-link>
                            </dd>
                        </dl>
                    </dl>-->

                    <dl class="content_list mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-file-text-o  mr-2"></i>
                            Real-time Info
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="columnsearching" value="Policy">Policy</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Trade">Trade</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Investment">Investment</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Facility Connectivity">Infrastructure</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Economy">Economy</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Industry">Industry</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="columnsearching" value="Video">Video</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/information/1" class="nav-link text-primary">
                                    More
                                </a>
                            </dd>
                        </dl>
                    </dl>
                    <dl class="content_list mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-building-o  mr-2"></i>
                            Belt and Road Weekly
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="/db/#/report/5009">Latest Issue</a>
                            </dd>
                        </dl>
                    </dl>
                    <dl class="content_list mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-cubes  mr-2"></i>
                            China Factbox
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Anhui">Anhui</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Beijing">Beijing</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Chongqing">Chongqing</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Fujian">Fujian</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Guangdong">Guangdong</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Henan">Henan</a>
                            </dd>
                            <dd class="p-2 mb-0"><!--hot_back-->
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.cf_report_id" :report_year="this.cf_report_year" report_type="" value="Jiangsu">Jiangsu</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a :href="this.cf_report_url" class="nav-link text-primary">
                                    More
                                </a>
                            </dd>
                        </dl>
                    </dl>
                    <dl class="content_list isr mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-newspaper-o  mr-2"></i>Research Reports
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="getReports" :report_id="this.co_report_id" report_type="China OGP" :report_year="this.co_report_year">China OGP</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="getReports" :report_id="this.t_report_id" report_type="Trade">Trade</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="getReports" :report_id="this.bt_report_id" report_type="Bilateral Trade Reports" :report_year="this.bt_report_year">Bilateral Trade</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="getCountryReport" :report_id="this.f_report_id" value="" :report_year="this.f_report_year" report_type="FDI">FDI</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="javascript:;" @click="getReports" :report_id="this.c_report_id" report_type="Consulting">Consulting</a>
                            </dd>
                        </dl>
                    </dl>
                    <!--<dl v-if="leftLists['Economic Data']" class="content_list isr mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-database  mr-2"></i>Economic Data
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Macro">Macro</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Industry">Industry</a>
                            </dd>
                             <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Company">Company</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Transaction">M&As</a>
                            </dd>
                        </dl>
                    </dl>-->
                    <dl class="content_list isr mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-search  mr-2"></i>Economic Data
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Macro">Macro</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Industry">Industry</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Company">Company</a>
                            </dd>
                            <dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Transaction">M&As</a>
                            </dd>
                            <!--<dd class="p-2 mb-0">
                                <a href="/db/#/data/SearchModule/Patent">Patent</a>
                            </dd>-->
                        </dl>
                    </dl>
                    <dl class="content_list isr mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-search  mr-2"></i>Credit Information
                        </dt>
                        <dl class="d-flex flex-wrap mb-0">
                            <dd class="p-2 mb-0">
                                <a href="/db/#/credits">Company Inquiry</a>
                            </dd>
                        </dl>
                    </dl>
                    <dl class="content_list mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-window-restore  mr-2"></i>
                            <a href="/db/#/brand/BigFrame">China Brands</a>
                        </dt>
                    </dl>
                    <dl class="content_list mb-0">
                        <dt class="list_title pl-3">
                            <i class="fa fa-graduation-cap  mr-2"></i>
                            <a href="/db/#/consult_particulars_organization/10/1">Consulting Service</a>
                        </dt>
                    </dl>
                </div>
            </div>
        </div>
        <div class="col-md-8 pl-0 pt-3 smpin" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
            <div class="right_content p-0 m-0" :class="!countryreportShow&&!reportShow ? 'chuan-show' : 'chuan-hide'" style="background: #fff;">
                <div class="right_list_content">
                    <p id="right_content_title" class="pl-4 mb-0">
                        <i class="fa fa-crosshairs mr-2"></i> Information Convergence
                        <!--<span class="myBtn" @click='goback()' v-if="!viewToggle">功能导航</span>-->
                    </p>
                    <form>
                        <div class="d-flex flex-wrap pl-4 right_content_dropdown f15">

                            <div><span class="text-black-50">Categories：</span></div>
                            <!--<div class="ml-3 mr-3 text-muted mlr-0">
                                <div class="dropdown">
                                    <li class="dropdown-toggle" data-toggle="dropdown" >
                                        <span>{{this.nationsSelected}}</span>
                                    </li>
                                    <div class="dropdown-menu nano statenano" style="overflow-y: scroll;height: 470px;">

                                        <div class="nano-content">

                                            <a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateState(value)" href="javascript:;">{{value}}</a>

                                        </div>
                                    </div>
                                </div>
                            </div>-->
                            <div class="ml-3 mr-3 text-muted mlr-0">
                                <div class="dropdown">
                                    <li class="dropdown-toggle" data-toggle="dropdown">
                                        <span>{{this.classifysSelected}}</span>
                                    </li>
                                    <div class="dropdown-menu nano" style="overflow-y: scroll;height: 400px;width: 195px;">

                                        <div class="nano-content">
                                            <a class="dropdown-item" v-for="(value, key) in classifys" @click="filtrateClassifys(value)" href="javascript:;">{{value}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-3 mr-3 text-muted mlr-0">
                                <div class="dropdown">
                                    <li class="dropdown-toggle" data-toggle="dropdown">
                                        <span>{{this.industrysSelected}}</span>
                                    </li>
                                    <div class="dropdown-menu nano" style="overflow-y: scroll;height: 470px;width: 300px;">

                                        <div class="nano-content">
                                            <a class="dropdown-item" v-for="(value, key) in industrys" @click="filtrateindustry(key,value)" href="javascript:;">{{value}}</a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row  p-0 m-0 video_breviary nano" id="video_breviary">
                        <div class="nano-content w-100" id="home_right_list" :class="{'cur':!viewToggle}">
                            <h4 class="pl-4 mt-3 f20" v-show="reveal">
                                Sort By
                                <!--<mark v-if="this.nationsSelected != 'Global' && this.nationsSelected != ''">{{this.nationsSelected}}</mark>-->
                                <mark v-if="this.classifysSelected != 'All news' && this.classifysSelected != ''">{{this.classifysSelected}}</mark>
                                <mark v-if="this.industrysSelected != 'All industries' && this.industrysSelected != ''">{{this.industrysSelected}}</mark>
                            </h4>
                            <ul class="list-unstyled w-100">
                                <li v-for="(value, key, index) in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">
                                    <!--文章-->
                                    <div v-if="value.modelType == 'content'" class="w-100" style="display: contents">
                                        <input type="hidden" :value='value.id' />
                                        <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                                        <div class="media-body">
                                            <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                                <i class="fa fa-file-text-o"></i>　</a>-->
                                            <h5>
                                                <router-link class="f18 text-dark font-weight-bold title_font" :value="value.resourceId" :to ="{name:'articleId', params: {id:1, contentid: subContentId(value.resourceId)}}" >
                                                    {{ value.title }}
                                                </router-link>
                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{ value.title }}</a>-->
                                            </h5>

                                            <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted ">

                                                <span>{{value.description}}</span>

                                            </div>
                                            <div class="clearfix" style="line-height: 22px;">
                                                <!--<div class="float-left">
                                                    <img src="../../../assets/images/silkRoadBase/collectsm.png">
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>-->
                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{ value.catName }}</a></span>
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>
                                                <div class="float-left">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>

                                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                                        </div>
                                    </div>
                                    <!--组图-->
                                    <div v-if="value.modelType == 'images'" class="w-100" style="display: contents">
                                        <input type="hidden" :value='value.id' />
                                        <div class="media-body">
                                            <h5>
                                                <router-link  class="f18 text-dark font-weight-bold title_font"  :to ="{name:'articleId', params: {id:1, contentid: subContentId(value.resourceId)}}" >
                                                    {{ value.title }}
                                                </router-link>
                                            </h5>
                                            <div class="images">
                                                <img v-for="(value, key, index) in subThumb(value.thumb)" :src="value" alt="" />
                                                <!--<img src="https://img.imsilkroad.com/a/thumb/10001/201905/e4f08ea298215f35f48948a2e275e9cd.jpeg@w1096_h822.jpeg" alt="" />-->
                                                <!--<img src="https://img.imsilkroad.com/a/thumb/10001/201905/e4f08ea298215f35f48948a2e275e9cd.jpeg@w1096_h822.jpeg" alt="" />-->
                                            </div>
                                            <div class="clearfix" style="line-height: 22px;">

                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{value.catName}}</a></span>
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>
                                                <div class="float-left">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--视频-->
                                    <div v-if="value.modelType == 'video'" class="w-100" style="display: contents">
                                        <img class="mr-3 img-thumbnail probations_img" :src="value.thumb" />
                                        <div class="media-body">
                                            <h5>
                                                <i class="fa fa-film mr-2"></i>
                                                <router-link class="f15 text-dark font-weight-bold title_font" :value="value.resourceId" :to ="{name:'videoId',params :{id:1,contentid:subContentId(value.resourceId)}}">{{ value.title }}</router-link>
                                            </h5>
                                            <p class="f13">Time:　{{formatSeconds(duration(value.description))}}</p>
                                            <div class="clearfix" style="line-height: 22px;">
                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p-11"><a href="javascript:;" @click="filtrateClassifys(value.catName)">{{ value.catName }}</a></span>

                                                </div>
                                                <div class="float-left pr-3 pl-3" v-if="value.published">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                                </div>
                                                <div class="float-left" v-if="value.published">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--音频-->
                                    <div v-if="value.modelType == 'audio'" class="w-100" style="display: contents">
                                        <img class="mr-3 img-thumbnail probations_img" :src="value.thumb" />
                                        <div class="media-body">
                                            <h5>
                                                <a :href="value.url" class="f18 text-dark font-weight-bold title_font">

                                                    {{ value.title }}
                                                </a>
                                            </h5>
                                            <p class="f13">Time:　{{formatSeconds(duration(value.description))}}</p>
                                            <div class="clearfix" style="line-height: 22px;">
                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p-11"><a href="javascript:;" @click="filtrateClassifys(value.catName)">{{ value.catName }}</a></span>

                                                </div>
                                                <div class="float-left pr-3 pl-3" v-if="value.published">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                                </div>
                                                <div class="float-left" v-if="value.published">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--杂志-->
                                    <div v-if="value.modelType == 'magazine' " class="w-100" style="display: contents">

                                        <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                                        <div class="media-body">
                                            <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                                <i class="fa fa-file-text-o"></i>　</a>-->
                                            <h5>
                                                <a :href="value.url" class="f18 text-dark font-weight-bold title_font">

                                                    {{ value.title }}
                                                </a>

                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{ value.title }}</a>-->
                                            </h5>

                                            <div v-if="value.thumb ==''" class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">

                                                <span>{{value.description}}</span>

                                            </div>
                                            <div class="clearfix" style="line-height: 22px;">
                                                <!--<div class="float-left">
                                                    <img src="../../../assets/images/silkRoadBase/collectsm.png">
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>-->
                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{ value.catName }}</a></span>
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>
                                                <div class="float-left">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>

                                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                                        </div>
                                    </div>
                                    <!--项目-->
                                    <div v-if="value.modelType=='project'" class="w-100" style="display: contents">
                                        <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" style="padding: 0.25rem;" />
                                        <div class="media-body">
                                            <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat"><i class="fa fa-file-text-o"></i>{{ value.catName }}</a>-->
                                            <h5>
                                                <router-link :to="{path:'/project', query :{url:value.url}}" tag="a" class="f18 text-dark font-weight-bold title_font">
                                                    {{value.title}}
                                                </router-link>
                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{value.title}}</a>-->
                                            </h5>
                                            <dl class="card-text text-muted pl-3 p-3 pt-0 pb-0">
                                                <dt>投资规模</dt>
                                                <dd>{{JSON.parse(value.description).desInvestScale}}</dd>
                                                <dt>行业</dt>
                                                <dd>{{JSON.parse(value.description).desIndustry}}</dd>
                                                <dt>区域</dt>
                                                <dd>{{JSON.parse(value.description).desRegion}}</dd>
                                            </dl>
                                            <div class="clearfix" style="line-height: 22px;">

                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{ value.catName }}</a></span>
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                                                </div>
                                                <div class="float-left">
                                                    <span class="f12 text-muted">投融资结束时间{{JSON.parse(value.description).desEndTime}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--数据-->
                                    <div v-if="value.modelType =='data'" class="w-100 homeDataList">
                                        <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                            <i class="fa fa-file-text-o"></i>{{ value.catName }}</a>-->
                                        <h5>
                                            <!--<a href="#" @click="gotoIframe(value.url)" target="_blank" class="f18 text-dark font-weight-bold">{{value.title}}</a>-->
                                            <router-link :to="{path:'/datapage', query :{url:value.url}}" tag="a" class="border border-0 f18 text-dark font-weight-bold title_font">
                                                {{value.title}}
                                            </router-link>
                                        </h5>
                                        <div class="media-body">

                                            <line-chart :chartdata="value.description" />
                                            <!--<div class="media-foot font-weight-light text-muted mt-2">{{timeDiff(value.published)}}</div>-->
                                        </div>

                                        <div class="clearfix" style="line-height: 22px;">

                                            <div class="float-left">
                                                <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{ value.catName }}</a></span>
                                            </div>
                                            <div class="float-left pr-3 pl-3">
                                                <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                            </div>
                                            <div class="float-left">
                                                <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 直播、投票、专栏、专题、活动、链接 -->
                                    <div v-if="value.modelType == 'live' || value.modelType == 'vote' || value.modelType == 'space' || value.modelType == 'special' || value.modelType == 'activity' || value.modelType == 'link'" class="w-100" style="display: contents">
                                        <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                                        <div class="media-body">
                                            <h5>
                                                <a :href="value.url" class="f18 text-dark font-weight-bold title_font">

                                                    {{ value.title }}
                                                </a>

                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{ value.title }}</a>-->
                                            </h5>

                                            <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted ">

                                                <span>{{value.description}}</span>

                                            </div>
                                            <div class="clearfix" style="line-height: 22px;">
                                                <div class="float-left">
                                                    <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:;">{{ value.catName }}</a></span>
                                                </div>
                                                <div class="float-left pr-3 pl-3">
                                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                                </div>
                                                <div class="float-left">
                                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                                </div>
                                            </div>

                                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                                        </div>
                                    </div>
                                </li>
                                <!--<p class="text-center"><i class="fa fa-spinner fa-pulse"></i></p>-->
                                <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                            </ul>
                            <div v-if="endShow" class="w-100">
                                <p class="text-center p-2">loading....</p>
                            </div>
                            <div v-if="!loadShow&&homeLists.length ==0" class="nodata text-center ">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                                <p class="text-center p-2">loading</p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="right_content p-0 m-0" :class="reportShow ? 'chuan-show' : 'chuan-hide'" style="background: #fff;">
                <div class="right_list_content">
                    <p id="right_content_title" class="pl-4 mb-0">
                        <i class="fa fa-crosshairs mr-2"></i> {{this.province}}
                    </p>
                    <div class="row  p-0 m-0 video_breviary nano video_breviarys">
                        <div class="nano-content w-100" :class="{'cur':!viewToggle}">
                            <ul class="list-unstyled w-100">
                                <li v-for="(value, key, index) in reports[reportsKey]" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">
                                    <!--杂志-->
                                    <div class="w-100" style="display: contents">

                                        <img v-if="value.image!=''" class="mr-3 img-thumbnail abstract_img" :src="value.image" />
                                        <div class="media-body">
                                            <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                                <i class="fa fa-file-text-o"></i>　</a>-->
                                            <h5>
                                                <a :href="'/db/#/countryreport/5008/2018/'+value.eid" class="f18 text-dark font-weight-bold title_font">

                                                    {{ value.title }}
                                                </a>

                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{ value.title }}</a>-->
                                            </h5>

                                            <div class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">

                                                <span>{{value.description}}</span>

                                            </div>

                                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                                        </div>
                                    </div>
                                </li>
                                <!--<p class="text-center"><i class="fa fa-spinner fa-pulse"></i></p>-->
                                <p class="text-center" v-if="loadShowReports"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                            </ul>
                            <div v-if="reports.length ==0&&!loadShowReports" class="nodata text-center ">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                                <p class="text-center p-2">loading</p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="right_content p-0 m-0" :class="countryreportShow ? 'chuan-show' : 'chuan-hide'" style="background: #fff;">
                <div class="right_list_content">
                    <p id="right_content_title" class="pl-4 mb-0">
                        <i class="fa fa-crosshairs mr-2"></i> {{this.report_type}}
                    </p>
                    <div style="min-height: 580px" class="row  p-0 m-0 video_breviary nano video_breviarys" id="video_breviary video_breviarys">
                            <div class="nano-content w-100" id="home_right_list1" :class="{'cur':!viewToggle}">
                            <ul class="list-unstyled w-100">
                                <li v-for="(value, key, index) in this.reportses" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">
                                    <!--杂志-->
                                    <div class="w-100" style="display: contents">

                                        <img v-if="value.image!=''" class="mr-3 img-thumbnail abstract_img" :src="value.image" />
                                        <div class="media-body">
                                            <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                                <i class="fa fa-file-text-o"></i>　</a>-->
                                            <h5>
                                                <a :href="'/db/#/report/'+report_id+'/issue/'+value.eid" class="f18 text-dark font-weight-bold title_font">

                                                    {{ value.title }}
                                                </a>

                                                <!--<a :href="value.url" target="_blank" class="f18 text-dark font-weight-bold">{{ value.title }}</a>-->
                                            </h5>

                                            <div class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">

                                                <span>{{value.description}}</span>

                                            </div>

                                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                                        </div>
                                    </div>
                                </li>
                                <!--<p class="text-center"><i class="fa fa-spinner fa-pulse"></i></p>-->
                                <p class="text-center" v-if="loadShowReport"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                            </ul>
                            <div v-if="reportses.length ==0&&!loadShowReport" class="nodata text-center ">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                                <p class="text-center p-2">loading</p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LineChart from './Chart.vue'
    export default({
        name: 'home',
        components: {
            LineChart
        },
        data: function() {
            return {
                nations: [],
                classifys: [],
                industrys: [],
                homeLists: [],
                industryTexts: [],
                classifysTexts: [],
                nationsTexts: [],
                leftLists:[],
                nationsSelected: 'Global',
                classifysSelected: 'All news',
                industrysSelected: 'All industries',
                industryID:'0',	//分类ID
                page: 0,
                total_page: 1,
                reveal: false,
                token: '',
                chartdata: null,
                viewToggle:true,
                clickToggle:true,
                specail:false, //特殊处理 小于544px
                screenWidths:"",
                loadShow:true,
                endShow:false,
                reports:[],
                reportses:[],
                reportShow: false,
                province:'',
                report_type: '',
                report_page: 1,
                report_page_size: 10,
                report_total_page: 1,
                countryreportShow: false,
                loadShowReport: false,
                loadShowReports: false,
                reportsKey: 'China',
                report_id:0,
                cf_report_id:5008,
                cf_report_year:2018,
                cf_report_url:'/db/#/countryreport/5008/2018',
                co_report_id:5021,
                co_report_year:2019,
                t_report_id:5020,
                bt_report_id:5022,
                bt_report_year:2018,
                f_report_id:5010,
                f_report_year:2017,
                c_report_id:5019,
            }
        },

        created: function() {
            var _this = this;
            this.$axios.post('/api/pc/getmenu').then(function (data) {
                var leftLists = data.data.data;
                $.each(leftLists, function (ii,ee) {
                    if(ee.id=='5021'){
                        _this.co_report_id = ee.id;
                        _this.co_report_year = ee.year;
                    }
                });
                $.each(leftLists.Reports, function (i,e) {
                    if(e.id=='5008'){
                        _this.cf_report_id = e.id;
                        _this.cf_report_year = e.year;
                        _this.cf_report_url = '/db/#/'+e.route+'/'+e.id+'/'+e.year;
                    }
                    if(e.id=='5020'){
                        _this.t_report_id = e.id;
                    }
                    if(e.id=='5022'){
                        _this.bt_report_id = e.id;
                        _this.bt_report_year = e.year;
                    }
                    if(e.id=='5010'){
                        _this.f_report_id = e.id;
                        _this.f_report_year = e.year;
                    }
                    if(e.id=='5019'){
                        _this.c_report_id = e.id;
                    }
                });
                console.log(leftLists);
            }, function (response) {
                console.info(response);
                if (response) {
                    console.log("失败");
                }
            });
            this.viewToggle=this.IsPC();
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
            var self = this;
            this.$axios.post('/api/pc/getmenu').then(function(data) {
                var leftLists = data.data.data;
                self.leftLists = leftLists;
                //console.log(self.leftLists);
            }, function(response) {
                console.info(response);
                if(response) {
                    console.log("失败");
                }
            })

            //请求select框
            this.$axios.post('/api/pc/getquery').then(function(data) {
                var nations = data.data.data.nation; //国家
                var classifys = data.data.data.classify; //分类
                var industrys = data.data.data.industry; //行业
                self.nations = nations;
                self.classifys = classifys;
                self.industrys = industrys;
            }, function(response) {
                console.info(response);
                if(response) {
                    console.log("失败");
                }
            });
            var classify = self.classifysSelected;
            if(classify=='All news'){
                classify = 0;
            }

            //首页右侧列表请求
            this.token = '';
            this.$axios({
                url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/'+ classify +'/0',
                method: 'get',
                headers: {
                    token: this.token
                }

            }).then(function(data) {
                var homeLists = data.data.results;
                self.token = data.data.token;
                self.homeLists = homeLists;
                self.total_page = data.totalPage;
                self.loadShow = false;
            }, function(response) {
                console.info(response);
                if(response) {
                    console.log("失败");
                }
            })
        },
        mounted:function() {
            const that = this;
            this.$nextTick(function () {

                document.getElementById('home_right_list').addEventListener('scroll', that.handleScroll,true);
                document.getElementById('home_right_list1').addEventListener('scroll', that.handleScrolls,true);
            })
            this.load();
            $(".statenano").nanoScroller();

            // window.onresize = () => {
            //     return (() => {
            //         that.screenWidths = document.body.clientWidth
            //     })()
            // }
        },
        methods: {
            getCountryReport() {
                var atPresentVal = event.target.getAttribute("value");
                var report_id = event.target.getAttribute("report_id");
                var report_year = event.target.getAttribute("report_year");
                var report_type = event.target.getAttribute("report_type");
                var that = this;
                that.loadShowReports = true;
                that.reportShow = true;
                that.countryreportShow = false;
                that.reports = [];
                that.province = atPresentVal ? atPresentVal : report_type;
                that.$axios.post('/api/pc/getreportcountry', {
                    id: report_id,
                    year:report_year,
                    country:atPresentVal
                }).then(function(data) {
                    that.loadShowReports = false;
                    if (data.data.state) {
                        that.reports = data.data.data;
                        that.province = atPresentVal ? atPresentVal : report_type;
                        // this.clickToggle=false;
                        /*this.getissues = data.data.data;
                        if (this.getissues) {
                            this.selectedKey = Object.keys(this.getissues)[0];
                        }*/
                    }

                })
            },
            getReports() {
                var report_id = event.target.getAttribute("report_id");
                var report_type = event.target.getAttribute("report_type");
                var self = this;
                self.loadShowReport = true;
                self.reportShow = false;
                self.countryreportShow = true;
                self.reportses = [];
                self.report_type = report_type;
                self.$axios.post('/api/pc/getissue', {
                    id: report_id,
                    current_page: 1,
                    page_size: self.report_page_size
                }).then(data => {
                    //console.log(data);
                    self.loadShowReport = false;
                    self.reportses = data.data.data.data;
                    self.report_total_page = Math.ceil(data.data.data.total / self.report_page_size);
                    self.report_id = report_id;
                    self.report_type = report_type;
                    /*var getissues = data.data.data.data;
                    self.total_page = Math.ceil(data.data.data.total / self.page_size);
                    self.getissues = getissues;*/
                })
            },
            goback(){
                this.clickToggle=!this.clickToggle;
                this.load();
            },
            filtrateState:function(e){		//国家
                this.reveal = true;
                let that = this;
                that.page = 0;
                that.nationsSelected = e;

                var column = encodeURI(e);							//全部国家
                var classify = encodeURI(that.classifysSelected);	//All news
                var industry = that.industryID;						//All industries
                if(e == 'Global'){
                    column = 0;
                }
                if(that.classifysSelected == 'All news'){
                    classify = 0;
                }
                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                }, function(response) {
                    console.info(response);
                    if(response) {
                        console.log("失败");
                    }
                })
            },
            filtrateClassifys:function(e){		//分类
                this.reveal = true;
                let that = this;
                that.page = 0;
                that.classifysSelected = e;
                var column = encodeURI(that.nationsSelected);		//全部国家
                var classify = encodeURI(e);						//All news
                var industry = that.industryID;						//All industries
                if(that.nationsSelected == 'Global'){
                    column = 0;
                }
                if(e == 'All news'){
                    classify = 0;
                }
                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                }, function(response) {
                    console.info(response);
                    if(response) {
                        console.log("失败");
                    }
                })
            },
            filtrateindustry:function(e,val){		//行业
                this.reveal = true;
                let that = this;
                that.page = 0;
                var column = encodeURI(that.nationsSelected);		//全部国家
                var classify = encodeURI(that.classifysSelected);	//All news
                var industry = e;									//All industries
                that.industryID = e;
                that.industrysSelected = val;
                if(that.nationsSelected == 'Global'){
                    column = 0;
                }
                if(that.classifysSelected == 'All news'){
                    classify = 0;
                }
                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                }, function(response) {
                    console.info(response);
                    if(response) {
                        console.log("失败");
                    }
                })
            },

            column: function() {
                var industry = this.industrysSelected; //分类value
                var column = encodeURI(this.nationsSelected);
                var acquireVal = encodeURI(event.target.getAttribute("value"));
                let that = this;
                that.page = 0;
                if(acquireVal == 'All news'){
                    acquireVal = 0;
                }
                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + acquireVal + '/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                })

            },
            columnClassify: function() {				//左侧国家点击
                var acquireVal = encodeURI(event.target.getAttribute("value"));
                $(".nano").nanoScroller(); //初始滚动条
                $(".nano").nanoScroller({scroll: 'top'});

                var atPresentVal = event.target.getAttribute("value");	//点击的国家
                var column;
                var classify;
                var industry;

                let that = this;
                that.page = 0;
                that.reveal = true;

                that.nationsSelected = atPresentVal;



                if(atPresentVal == 'Global'){
                    column = 0;
                }else{
                    column = encodeURI(atPresentVal);
                }

                if(that.classifysSelected == 'All news'){
                    classify = 0;
                }else{
                    classify = encodeURI(that.classifysSelected);	//All news
                }

                if(that.industrysSelected == 'All industries'){
                    industry = 0;
                }else{
                    industry = that.industryID;	//All industries
                }

                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/'+classify+'/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.clickToggle=!that.clickToggle;
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                })

            },
            //	左侧栏目点击检索
            columnsearching: function() {
                //$(".nano").nanoScroller(); //初始滚动条
                //$(".nano").nanoScroller({scroll: 'top'});
                var atPresentVal = event.target.getAttribute("value");	//点击的国家
                var column;
                var classify;

                let that = this;
                that.page = 0;
                that.reveal = true;

                that.classifysSelected = atPresentVal;
                var industry = that.industryID;						//All industries

                if(atPresentVal == 'All news'){
                    classify = 0;
                }else{
                    classify = encodeURI(atPresentVal);
                }

                if(that.nationsSelected == 'Global'){
                    column = 0;
                }else{
                    column = encodeURI(that.nationsSelected);	//Global
                }

                if(that.industrysSelected == 'All industries'){
                    industry = 0;
                }else{
                    industry = that.industryID;	//All industries
                }
                that.reportShow=false;
                that.countryreportShow=false;
                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/'+classify+'/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.clickToggle=!that.clickToggle;
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                })

            },
            industryching:function(e){			//左侧行业点击
                var industry = event.target.getAttribute("value");
                let that = this;
                that.reveal = true;
                that.industrysSelected = e.currentTarget.innerText;
                var column;
                var classify;

                that.industryID = industry;

                if(that.classifysSelected == 'All news'){
                    classify = 0;
                }else{
                    classify = encodeURI(that.classifysSelected);
                }

                if(that.nationsSelected == 'Global'){
                    column = 0;
                }else{
                    column = encodeURI(that.nationsSelected);	//Global
                }

                that.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/'+classify+'/' + industry,
                    method: 'get'
                }).then(function(data) {
                    that.clickToggle=!that.clickToggle;
                    that.homeLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;
                })
            },
            handleScroll() {
                var industry ;
                var column ;
                var classify ;
                if(this.nationsSelected == 'Global'){
                    column = 0;
                }else{
                    column = encodeURI(this.nationsSelected);		//国家
                }
                if(this.classifysSelected == 'All news'){
                    classify = 0;
                }else{
                    classify = encodeURI(this.classifysSelected);	//分类
                }
                if(this.industrysSelected == 'All industries'){
                    industry = 0;
                }else{
                    industry = this.industryID; 			//行业
                }

                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度
                if(((all - 20) < (top + client)) && !this.loadShow) {
                    this.page++;
                    if(this.page > this.total_page) {
                        this.endShow = true;
                        return;
                    }
                    this.loadShow = true;
                    var self = this;
                    this.$axios({
                        url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/' + this.page + '/' + column + '/' + classify + '/' + industry,
                        method: 'get',
                        headers: {
                            token: self.token
                        }

                    }).then(function(data) {
                        var homeListes = data.data.results;
                        JSON.stringify(homeListes);
                        self.token = data.data.token;
                        var new_homeLists = self.homeLists.concat(homeListes);
                        self.homeLists = new_homeLists;
                        self.total_page = data.data.totalPage;
                        self.loadShow = false;
                    }, function(response) {
                        console.info(response);
                        if(response) {
                            console.log("失败");
                        }
                    })
                }

            },
            handleScrolls() {
                var top = document.getElementById('home_right_list1').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list1').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list1').scrollHeight; // 总高度
                //console.log(123123);
                if(((all - 20) < (top + client)) && !this.loadShowReport) {
                    this.report_page++;
                    if(this.report_page > this.report_total_page) {
                        return;
                    }
                    let that = this;
                    that.loadShowReport = true;
                    this.$axios.post('/api/pc/getissue', {
                        id: that.report_id,
                        current_page: that.report_page,
                        page_size: that.report_page_size
                    }).then(data => {
                        var getissues = data.data.data.data;
                        that.reportses = that.reportses.concat(getissues);
                        that.loadShowReport = false;

                        /*var getissues = data.data.data.data;
                        that.getissues = that.getissues.concat(getissues);
                        that.loadShowReport = false;*/
                    })
                }
            },
            timeDiff(published) {

                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

                if(days > 0) {
                    if (days > 7) {
                        var time = new Date(published);
                        var m = time.getMonth()+1;
                        var d = time.getDate();
                        return m + '-' + d;
                    } else {
                        if(days==1){
                            return days + 'day ago';
                        }
                        return days + 'days ago';
                    }
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
                if (seconds > 0) {
                    if(seconds==1){
                        return  seconds + 'second ago';
                    }
                    return  seconds + 'seconds ago';
                }
            },
            subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');

                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
            duration(duration) {
                // 查找 站点是否存在
                var start = duration.indexOf('|');

                if (start >= 0) {
                    var arr = duration.split('|');
                    return arr[1];
                } else {
                    return duration;
                }

            },
            formatSeconds(value) {
                var secondTime = parseInt(value); // 秒
                var minuteTime = 0; // 分
                if(secondTime > 60) {
                    minuteTime = parseInt(secondTime / 60);
                    secondTime = parseInt(secondTime % 60);
                    return this.PrefixInteger(parseInt(minuteTime), 2) + ':' + this.PrefixInteger(secondTime, 2);
                } else {
                    return "00:" + this.PrefixInteger(parseInt(secondTime), 2);
                }

            },
            PrefixInteger(num, n) {
                return(Array(n).join(0) + num).slice(-n);
            },
            subThumb(thumb) {
                if (thumb) {
                    var thumb_arr = thumb.split('|');
                    return thumb_arr.slice(0, 3);
                } else {
                    return []
                }
            }

        },
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
        watch: {
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
        },
    })

</script>
<style scoped type="text/css">
    .dropright .dropdown-menu{
        margin-left: 0 !important
    }
    .p11{
        padding: .125rem .375rem!important;
    }
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    .autoHeight{
        height: auto!important;
    }
    .myBtn{
        height:30px;
        display:block;
        position:absolute;
        top:10px;
        padding:10px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:10px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    #right_content_title{
        position: relative;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    #consult_left_content{
        position: relative;
    }
    .images{
        margin-bottom:15px;
    }
    .images img{
        height:125px;
        max-width: 30%;
        display: inline-block;
        margin-right: 10px;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .chuan-show{
        display: block;
    }
    .chuan-hide{
        display: none;
    }
    .title_font{
        font-family: Georgia
    }
    @media only screen and (max-width: 500px){
        .show-con{
            display: block !important;
        }
    }

</style>
